import $ from 'jquery';
window.$ = window.jQuery = $;

import 'bootstrap';
import '@fortawesome/fontawesome-free/js/all.js';
